import styled from 'styled-components';
import { TextInput } from 'grommet';

export const TextInputBorderless = styled(TextInput)`
  border: none;
`;

export const StyledTextInput = styled(TextInput)`
  border: none;
  &.is-read-only:hover {
    cursor: pointer;
  }
`;
